export default class rs {
  constructor(t) {
    (this.wc = t), (this.wc = t);
  }
  xc(t) {
    return null == this.wc || this.wc === t[0];
  }
  static fromJson(t) {
    return new rs(t ? t.event_name : null);
  }
  bt() {
    return this.wc;
  }
}
